import { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';

import { KpiType } from '@/shared/types/api';
import { KPI_UNITS } from '@/shared/types/kpi';

/**
 * Auto-sets unit to "%" and max_value to 100 when KPI type is changed to RELATIVE.
 * Used by both the KPI dialog editor and the create-project KPI form.
 */
export function useAutoSetRelativeKpiDefaults(form: UseFormReturn<any>): void {
  useEffect(() => {
    const subscription = form.watch((value, { name }) => {
      if (name === 'type' && value.type === KpiType.RELATIVE) {
        form.setValue('unit', KPI_UNITS.relative['%'].toString());
        // Only set max_value as default if not already set
        if (value.max_value === undefined) {
          form.setValue('max_value', 100);
        }
      }
    });
    return () => subscription.unsubscribe();
  }, [form]);
}
